import React, { FC } from 'react'
import styles from './Tiles.module.scss'
import { TileType } from './types'
import SALink from 'components/SALink'

type TileProps = {
  tile: TileType
}
const TileList: FC<TileProps> = ({ tile }) => {
  const { categoryName, imageUrl, categoryUrl } = tile
  return (
    <div className={styles.tile}>
      <SALink href={categoryUrl} title={categoryName}>
        <img className={styles.image} src={imageUrl} alt={categoryName} width='260' height='182' />
      </SALink>

      <div className={styles.info}>
        <p className={styles.linkTitle}>
          <SALink href={categoryUrl} alt={categoryName}>
            {categoryName}
          </SALink>
        </p>
      </div>
    </div>
  )
}

export default TileList
